module.exports = __webpack_public_path__ + "img/cta-triumph.5b6e2348.jpg";